//import packages from node modules
import React,{useCallback,useEffect,useRef} from 'react'
import PropTypes from 'prop-types'
import {useSelector} from 'react-redux'
import {reduxForm,Field} from 'redux-form'
import {withRouter,useHistory} from 'react-router-dom'

//import shared components
import TextField from "../../../shared/form/textfield"

//import
import {
  requiredFieldValidation,
  emailFieldValidation,
  domainnameFieldValidation,
  nameFieldValidation
} from "../../../shared/form/validation";
import {getDataFromURL} from "../../../../utilities/function/urlparams"

import {getAppConfigValue} from "../../../../utilities/function/configuration";

import SolidButton from "../../../shared/button/solidbutton"
import Dropdown from "../../../shared/form/dropdown"
import Goback from '../../../shared/goback'

let SwitchForm = (props) =>{
  const {handleSubmit,location,initialize,checkToken} = props
  const history = useHistory()
  const {SwitchReduxForm} = useSelector(state=>({
    SwitchReduxForm: state.form.SwitchForm
  }))
  const {step} = getDataFromURL(location.search)
  const terms_link = getAppConfigValue("terms_link")
  const prevStep = useRef(null)
  const changeStepCallback = useCallback(()=>{
    if(prevStep.current !== step){
      try {
        const SwitchFormValues = JSON.parse(localStorage.getItem("SwitchForm"))
        initialize(SwitchFormValues)
      }catch (e) {}
      prevStep.current = step
    }
  },[step,initialize])
  useEffect(()=>{
    changeStepCallback()
  },[changeStepCallback])

  const renderCustomerFields = () =>{
    return (<>
        <div className={'of-switch-form__row'}>
          <div className={'of-switch-form__column'}>
            <Field component={TextField}
                   name={"email"}
                   label={'Email Address'}
                   validate={[requiredFieldValidation,emailFieldValidation]}
                   placeholder={'Email Address'}
            />
          </div>
        </div>
        <div className={'of-switch-form__row'}>
          <div className={'of-switch-form__column of-switch-form__column--half'}>
            <Field component={TextField}
                   name={"first_name"}
                   label={'First Name'}
                   validate={[requiredFieldValidation,nameFieldValidation]}
                   placeholder={'First Name'}
            />
          </div>
          <div className={'of-switch-form__column of-switch-form__column--half'}>
            <Field component={TextField}
                   name={"last_name"}
                   label={'Last Name'}
                   validate={[requiredFieldValidation,nameFieldValidation]}
                   placeholder={'Last Name'}
            />
          </div>
        </div>
        <div className={'of-switch-form__row'}>
          <div className={'of-switch-form__column'}>
            <div className={'of-switch-form__terms text-font-1-100'}>
              By clicking the <strong>Continue</strong> button below, you agree to <a className={'text-font-1-100'} href={terms_link} target={'_blank'}>Terms, Policies & Agreements</a>
            </div>
          </div>
        </div>
      </>)
  }
  const renderServiceFields = () => {
    const renderOtherTextField = () => {
      if(SwitchReduxForm && SwitchReduxForm.values){
        const {provider} = SwitchReduxForm.values
        if(provider==="Other"){
          return (
            <div className={'of-switch-form__row'}>
              <div className={'of-switch-form__column'}>
                <Field component={TextField}
                       name={"other_provider"}
                       label={'Your Provider Name'}
                       validate={[requiredFieldValidation]}
                       placeholder={'Please insert your provider name'}
                />
              </div>
            </div>
          )
        }
      }
      return (<></>)
    }
    return (<>
      <div className={'of-switch-form__row'}>
        <div className={'of-switch-form__column'}>
          <Field component={TextField}
                 name={"domain_name"}
                 label={'Your Domain Name'}
                 validate={[requiredFieldValidation,domainnameFieldValidation]}
                 placeholder={'www.'}
                 description={'Please enter the primary domain name attached to your existing hosting plan here, or your website URL e.g. my-website.com.au'}
          />
        </div>
      </div>
      <div className={'of-switch-form__row'}>
        <div className={'of-switch-form__column'}>
          <Field component={Dropdown}
                 name={"provider"}
                 label={'Your Provider'}
                 validate={[requiredFieldValidation]}
                 list={[{
                   label: 'GoDaddy',
                   value: 'GoDaddy'
                 },{
                   label: 'Crazy Domains',
                   value: 'CrazyDomain'
                 },{
                   label: 'Melbourne IT',
                   value: 'MelbourneIT'
                 },{
                   label: 'Netregistry',
                   value: 'Netregistry'
                 },{
                   label: 'Other',
                   value: 'Other'
                 }]}
                 placeholder={'Please select your provider'}
          />
        </div>
      </div>
      {renderOtherTextField()}
      <div className={'of-switch-form__row'}>
        <div className={'of-switch-form__column'}>
          <Field component={Dropdown}
                 name={"remaining_time"}
                 label={'Amount of time pre-paid'}
                 validate={[requiredFieldValidation]}
                 list={[{
                   label: 'Less than 1 Month',
                   value: 'P1M'
                 },{
                   label: '1 -3 Months',
                   value: 'P3M'
                 },{
                   label: '3 - 6 Months',
                   value: 'P6M'
                 },{
                   label: '6 - 12 Months',
                   value: 'P12M'
                 },{
                   label: 'More than 12 Months',
                   value: 'P12M'
                 }]}
                 placeholder={'How much time left on your invoice period?'}
          />
        </div>
      </div>
    </>)
  }
  const renderFields = () =>{
    switch (step) {
      case 'select-service':
        return renderServiceFields()
      default:
        return renderCustomerFields()
    }
  }
  const renderButton = () => {
    switch (step) {
      case 'select-service':
        return <SolidButton className={'of-switch-form__button'} type={"submit"}>Submit</SolidButton>
      default:
        return <SolidButton className={'of-switch-form__button'} type={"submit"}>Continue</SolidButton>
    }
  }
  const renderGobackLink = () => {
    if(step === 'select-service' || step === 'login'){
      if(!checkToken ||
        (checkToken && (checkToken.status==="error" ||
          !checkToken.status))
      ){
        return(
          <div className='of-switch-form__go-back'>
            <Goback onClick={()=>{
              try {
                if(SwitchReduxForm && SwitchReduxForm.values) {
                  localStorage.setItem('SwitchForm',JSON.stringify(SwitchReduxForm.values))
                }
                history.push(`${history.location.pathname}?a=switch`)
              }catch (e) {
                console.log(e)
              }
            }}>Go Back</Goback>
          </div>
        )

      }
    }
    return(<></>)
  }

  if(!step || step==='select-service'){
    return (<form className={'of-switch-form'} onSubmit={handleSubmit}>
      {renderFields()}
      {renderButton()}
      {renderGobackLink()}
    </form>)
  }

  return (<></>)
}

SwitchForm = withRouter(SwitchForm)

SwitchForm = reduxForm({
  form: 'SwitchForm'
})(SwitchForm)

SwitchForm.propTypes = {
  checkToken: PropTypes.object,
  handleSubmit: PropTypes.func,
  location: PropTypes.object,
  initialize: PropTypes.func
}

export default SwitchForm